import _ from 'lodash';
import { SET, CLEAR_PAGE_DATA } from './action-types';


export default function reducers(state = {}, action = { data: {} }) {
  switch (action.type) {
    case SET:
      _.assign(state, action.data);
      break;
    case CLEAR_PAGE_DATA:
      return {};
    default:
      return state;
  }

  return { ...state };
}
